import { render } from "./LeftTypeSelector.vue?vue&type=template&id=f2e3d050&scoped=true"
import script from "./LeftTypeSelector.vue?vue&type=script&lang=js"
export * from "./LeftTypeSelector.vue?vue&type=script&lang=js"

import "./LeftTypeSelector.vue?vue&type=style&index=0&id=f2e3d050&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e3d050"]])

export default __exports__